import { IpcBus } from 'shared/ipc/IpcBus'
import { IpcService } from 'shared/ipc/IpcService'

let serviceSingleton: IpcRendererService
export const getIpcService = (): IpcRendererService => {
  if (!window.Bridge) {
    throw new Error('window is missing electron bridge')
  }

  if (!serviceSingleton) {
    serviceSingleton = new IpcRendererService(window.Bridge.ipcBus as IpcBus)
  }

  return serviceSingleton
}

export class IpcRendererService extends IpcService {
  public constructor(private bus: IpcBus) {
    super()
  }

  public send(channel: string, data: any) {
    this.bus.send(channel, data)
  }
  /* eslint-disable */
  public handle(_channel: string, _callback: (event: any, data: any) => void) {
    throw 'UNIMPLEMENTED'
  }
  public listen(channel: string, callback: (event: any, data: any) => void) {
    this.bus.on(channel, callback)
  }
  public removeListener(channel: string, callback: (event: any, data: any) => void) {
    this.bus.removeListener(channel, callback)
  }
  public removeAllListeners(channel: string): void {
    this.bus.removeAllListeners(channel)
  }
}
